export default {
  'menu.openItem.add.item': 'Add Item',

  'menu.openItem.description.title': 'Use Case：For ordering dishes not listed on the menu.',
  'menu.openItem.description.instructions': 'Instructions',
  'menu.openItem.description.instructions.step1': '1. Add open items here.',
  'menu.openItem.description.instructions.step2': '2. In pos app, server selects suitable item.',
  'menu.openItem.description.instructions.step3': `3. Server customizes the item's name ,price,printers, then sends it to kitchen.`,

  'menu.openItem.table.column.name': 'Name',
  'menu.openItem.table.column.salesCategory': 'Sales Category',
  'menu.openItem.table.column.taxInclusionOption': 'Tax Inclusion Option',
  'menu.openItem.table.column.taxRate': 'Tax Rate',
  'menu.openItem.delete.secondaryConfirmationPrompt': 'Are You Sure to Delete This Open Item ?',

  'menu.openItem.edit.item': 'Edit Item',

  'menu.openItem.form.basicInfo': 'Basic information',
  'menu.openItem.form.taxes': 'Taxes',
  'menu.openItem.form.field.name': 'Name',
  'menu.openItem.form.field.name.required': 'Name is required',
  'menu.openItem.form.field.foreignName': 'Foreign Name',
  'menu.openItem.form.field.taxCode': 'Tax Code',
  'menu.openItem.form.field.taxCode.required': 'Tax Code is required',
  'menu.openItem.form.field.taxInclusionOption': 'Tax inclusion option',
  'menu.openItem.form.field.taxInclusionOption.prompt': `
    Item prices do not include tax; additional tax will be calculated based on the tax rate.
  `,
  'menu.openItem.form.field.salesCategory': 'Sales Category',
  'menu.openItem.form.field.salesCategory.prompt':
    'Sales generated from this open food will be calculated under the chosen category.',
};
